import { render } from "./StudentBasicData.vue?vue&type=template&id=77d026c1&scoped=true"
import script from "./StudentBasicData.vue?vue&type=script&lang=js"
export * from "./StudentBasicData.vue?vue&type=script&lang=js"

import "./StudentBasicData.vue?vue&type=style&index=0&id=77d026c1&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d026c1"]])

export default __exports__